import { render, staticRenderFns } from "./transferPage.vue?vue&type=template&id=10d1f60e&scoped=true&"
import script from "./transferPage.vue?vue&type=script&lang=js&"
export * from "./transferPage.vue?vue&type=script&lang=js&"
import style0 from "./transferPage.vue?vue&type=style&index=0&id=10d1f60e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d1f60e",
  null
  
)

export default component.exports